import {useMutation, useQueryClient} from "@tanstack/react-query";
import {EventAPI} from "../../services/network/event-api";
import {EVENT_ENDPOINTS} from "../../services/network/endpoints";
import {IEvent, IEventCreate} from "../../services/models/event";
import {toast} from "react-toastify";

export function useCreateEvent() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: [EVENT_ENDPOINTS.CREATE],
        mutationFn: (createData: Omit<IEventCreate, '_id' | 'owner'>) => EventAPI.create(createData),
        onError() {
            toast.error("Ошибка создания события");
        },

        onSuccess: () => {
            // Инвалидируем кэш списка событий, чтобы обновить их после создания нового
            queryClient.invalidateQueries({ queryKey: [EVENT_ENDPOINTS.FETCH_EVENTS] });
            toast.success("Новое событие создано");
        }
    });
}
